module.exports = __webpack_public_path__ + "img/icon-arrow-right-black.33307d48.svg";